module.exports = __webpack_public_path__ + "31685155cc042358fdda0f155c50c5df.png";